import React, { Component, useState, useEffect } from 'react';
import { Tree } from 'primereact/tree';
import CatService from '../../service/CatService';
import { useTranslation } from 'react-i18next';

export function CatTree(props){
    const {t} = useTranslation();
    const [nodes,setNodes]=useState(null);
    const [loading,setLoading]=useState(true);
    const [cat,setCat]=useState({id: 0, name: '', code: '', path: ''});

    useEffect(()=>{
        setNodes(createRootNode());
        setLoading(false);
    },[]);
    useEffect(()=>{
        if(props.catAction!=null)
        {
            if(props.catAction.method=='ADD')
                catAdded(props.catAction.cat);
            else if(props.catAction.method=='MODIFY')
                catChanged(props.catAction.cat);
            else if(props.catAction.method=='DELETE')
                catDeleted(props.catAction.cat);
            else if(props.catAction.method=='REFRESH')
                refresh();
        }
    },[props.catAction]);
    const refresh=()=>{
        var nds=createRootNode();
        setNodes(nds);
        setLoading(false);
        expandNode(nds[0]);
    }
    const createRootNode=()=>{
        return [{ key: 'root', label: t('Program Root'), leaf: false, catType:'ROOT', parentGroup:true, code:'ROOT', name:t('Program Root'),id:0, icon:'pi pi-home',expanded:false }];
    }
    const selectionChanged=(event)=>{
        var selectedCat = event.node;
        setCat(selectedCat);
        if(props.onSelect != null)
            props.onSelect(selectedCat);
    }
    const setCatIcon=(cat)=> {
        if (cat.catType == 'ROOT' && (cat.parentId))
            cat.icon = "pi pi-folder";
        else if (cat.catType == 'ROOT' && !(cat.parentId))
            cat.icon = "pi pi-server";
        else if (cat.catType == 'COURSE')
            cat.icon = "pi pi-book";
        else if (cat.catType == 'TOPIC')
            cat.icon = "pi pi-file";
    }
    const getChildCatType=(cat)=>{
        if(cat.catType == 'ROOT' && cat.parentGroup)
            return 'ROOT';
        else if(cat.catType == 'ROOT' && !cat.parentGroup)
            return 'COURSE';
        else if(cat.catType == 'COURSE')
            return 'TOPIC';
        else if(cat.catType == 'TOPIC')
            return 'TOPIC';
        return '';        
    }
    const catAdded = (cat)=>{
        console.log('CatTree:catAdded:'+JSON.stringify(cat));
        var nd = findNode(nodes[0],cat.parentId);
        if(nd != null)
        {
            console.log('CatTree::catAdded:'+nd.name);
            let value = [...nodes];            
            cat.leaf = false;
            if(cat.catType=='TOPIC' && cat.parentGroup==false)
                cat.leaf = true;

            setCatIcon(cat);
            cat.key = cat.id;
            cat.label = cat.name;
            if(!nd.children)
                nd.children=[];
            nd.children.push(cat);
            setNodes(value);
            setLoading(false);
        }
    }
    const catChanged = (cat)=>{
        console.log('CatTree:catChanged:'+JSON.stringify(cat));
        var nd = findNode(nodes[0],cat.id);
        if(nd != null)
        {
            let value = [...nodes];           
            nd.name = cat.name;
            nd.label = cat.name;
            nd.code = cat.code;
            setNodes(value);
            setLoading(false);
        }
    }    
    const catDeleted = (cat)=>{
        console.log('CatTree:catdeleted:'+JSON.stringify(cat));
        var nd = findNode(nodes[0],cat.parentId);
        if(nd != null && nd.children != undefined)
        {
            for(var i=0; i<nd.children.length; i++)
            {
                if(nd.children[i].key == cat.id)
                    nd.children.splice(i,1);
            }
            let value = [...nodes];           
            setNodes(value);
            setLoading(false);
        }
    }      
    const findNode=(node,id)=>{
        if(node.children == undefined)
            return null;
        for(var i = 0; i<node.children.length; i++)
        {
            var ch = node.children[i];
            if(ch.key == id)
                return ch;
            var r = findNode(ch,id);
            if(r!=null)
                return r;
        }
        return null;
    }
    const expandNode=(nd)=>{
        let node = { ...nd };
        node.children = [];
        let parentId = node.key == 'root' ? '' : node.key;
        let catType = getChildCatType(node);
        var ret = CatService.getCats(parentId,catType);
        ret.then(r => {
            for (var i = 0; i < r.length; i++) {
                r[i].key = r[i].id;
                r[i].label = r[i].name;
                r[i].leaf = false;
                if(r[i].catType=='TOPIC' && r[i].parentGroup==false)
                    r[i].leaf = true;
                setCatIcon(r[i]);
                node.children.push(r[i]);
            }
            //console.log("r=" + JSON.stringify(r));
            let value = [...nodes];
            //value[0] = node;
            nd.children = node.children;
            setNodes(value);
            setLoading(false);
        }).catch(err=>{
            console.log(err);
            props.showError(err.message);
        });
    }
    const loadOnExpand=(event)=>{
        if (!event.node.children) {
            expandNode(event.node);
        }
    }
    return (
        <Tree value={nodes} selectionMode="single" onExpand={loadOnExpand} onSelect={selectionChanged} />
    )
}

export default CatTree;